export const syntheticPreferredPaymentGroup = {
    groupName: "preferred",
    displayName: "Recommended for you",
    foldSize: 10,
    couponApplicable: true,
    meta: {
        multiPpmFoldSize: 3,
        isNew: true,
        disableMessage: "",
        intentFoldSize: 5,
        collectFoldSize: 1,
    },
    paymentMethods: [],
    isFrictionHiddenGroup: false,
    enabled: true,
    preferredGroup: false,
};
